export default {
  SET_HEIGHT: '@WS_EDITOR/TOPBAR/SET_HEIGHT',
};
